"use client";

import { useEffect } from "react";
import { reportClientError } from "@/lib/observability/report-error";
// global-error replaces the root layout, so it must pull in the global
// stylesheet itself to get the .btn / token classes (fonts fall back to
// system — acceptable for a last-resort error screen).
import "./globals.css";

/**
 * Last-resort error boundary — catches errors thrown by the root layout
 * itself, which the per-route `error.tsx` cannot. Must render its own
 * <html>/<body>. Best-effort report + a reload + phone escape hatch.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportClientError(error, { boundary: "global" });
  }, [error]);

  return (
    <html lang="de">
      <body className="min-h-screen bg-canvas">
        <div className="mx-auto flex min-h-screen max-w-xl flex-col items-center justify-center gap-6 px-6 text-center">
          <h1 className="text-2xl font-semibold text-ink-900">
            Es gab ein technisches Problem.
          </h1>
          <p className="text-ink-700">
            Bitte laden Sie die Seite neu. Wenn es weiterhin nicht klappt,
            erreichen Sie uns rund um die Uhr telefonisch.
          </p>
          <div className="flex flex-col items-center gap-3 sm:flex-row">
            <button type="button" onClick={reset} className="btn-primary btn-lg">
              Seite neu laden
            </button>
            <a href="tel:+497161970990" className="btn-secondary btn-lg tabnums">
              +49 7161 970 99 0
            </a>
          </div>
        </div>
      </body>
    </html>
  );
}
